/* ============================================
   DUDUK THEME - Main JavaScript
   Spacing Imagination
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ============================================
  // 0. GLOBAL PRICE FORMAT — strip .00 from all prices
  // ============================================
  function formatINR(paise) {
    const rupees = Math.round(paise / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // Strip .00 from any server-rendered price text
  document.querySelectorAll(
    '.product-price, .product-main-price, .product-original-price, ' +
    '.price-summary-total, .cart-total-price, .cart-item-price, ' +
    '.cart-subtotal span, .product-card .product-price, .addon-price'
  ).forEach(el => {
    el.textContent = el.textContent.replace(/\.00\b/g, '');
  });

  // ============================================
  // 1. HEADER SCROLL BEHAVIOR
  // ============================================
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ============================================
  // 2. NAV COLOR WASH (Desktop hover effect)
  // ============================================
  const colorWash = document.getElementById('nav-color-wash');
  const catColors = {
    playhouses: 'rgba(255, 65, 73, 0.06)',
    decor:      'rgba(112, 141, 255, 0.06)',
    furniture:  'rgba(73, 198, 100, 0.06)',
    diy:        'rgba(255, 220, 63, 0.06)',
  };

  document.querySelectorAll('.nav-item[data-cat]').forEach(item => {
    const cat = item.dataset.cat;
    item.addEventListener('mouseenter', () => {
      if (colorWash) {
        colorWash.style.background = catColors[cat] || 'transparent';
        colorWash.style.opacity = '1';
      }
    });
    item.addEventListener('mouseleave', () => {
      if (colorWash) colorWash.style.opacity = '0';
    });
  });

  // ============================================
  // 3. MOBILE NAV DRAWER
  // ============================================
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    mobileNav?.classList.add('open');
    mobileOverlay?.classList.add('visible');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav?.classList.remove('open');
    mobileOverlay?.classList.remove('visible');
    document.body.style.overflow = '';
  }

  hamburger?.addEventListener('click', openMobileNav);
  mobileClose?.addEventListener('click', closeMobileNav);
  mobileOverlay?.addEventListener('click', closeMobileNav);

  // ============================================
  // 4. CART DRAWER — handled entirely by the inline script in
  // layout/theme.liquid (window.openCart / window.renderCart).
  // ============================================

  // ============================================
  // 5. PRODUCT PAGE ADD-ONS
  // Price calculation is handled entirely by the inline script in
  // templates/product.liquid (the DUDUK_priceInit IIFE).
  // This section intentionally left empty to avoid conflicts.
  // ============================================

  // ATC — handled entirely by templates/product.liquid (fetch /cart/add.js
  // with selected add-on variants). No form interception needed here.

  // ============================================
  // 6. SIZE GUIDE INTERACTIVE ANIMATION
  // ============================================
  const sizeTiers = document.querySelectorAll('.size-tier');
  const sizeRoom = document.querySelector('.size-room');
  const sizeHouseSvg = document.getElementById('size-house-svg');
  const sizeRoomLabel = document.querySelector('.size-room-label');

  const sizeConfig = {
    small:  { width: '200px', height: '200px', label: '~3ft × 3ft', svgPx: 80 },
    medium: { width: '280px', height: '280px', label: '~4ft × 4ft', svgPx: 110 },
    large:  { width: '360px', height: '360px', label: '4ft+ range',  svgPx: 140 },
  };

  sizeTiers.forEach(tier => {
    tier.addEventListener('click', () => {
      sizeTiers.forEach(t => t.classList.remove('active'));
      tier.classList.add('active');
      const size = tier.dataset.size;
      const config = sizeConfig[size];
      if (sizeRoom && config) {
        sizeRoom.style.width = config.width;
        sizeRoom.style.height = config.height;
        if (sizeRoomLabel) sizeRoomLabel.textContent = config.label;
        if (sizeHouseSvg) {
          const svg = sizeHouseSvg.querySelector('svg');
          if (svg) { svg.setAttribute('width', config.svgPx); svg.setAttribute('height', config.svgPx); }
        }
      }
    });
  });

  // ============================================
  // 7. ACCORDION (Product details & FAQ)
  // ============================================
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item.open').forEach(o => {
        o.classList.remove('open');
        o.querySelector('.accordion-trigger')?.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============================================
  // 8. GALLERY THUMBNAILS
  // ============================================
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const galleryMainImg = document.querySelector('.gallery-main img');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const thumbSrc = thumb.querySelector('img')?.src;
      if (thumbSrc && galleryMainImg) {
        galleryMainImg.style.opacity = '0';
        galleryMainImg.style.transition = 'opacity 0.25s ease';
        setTimeout(() => {
          galleryMainImg.src = thumbSrc.replace(/\/200x200/, '/800x800');
          galleryMainImg.style.opacity = '1';
        }, 200);
      }
    });
  });

  // ============================================
  // 9. SCROLL REVEAL
  // ============================================
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => revealObserver.observe(el));
  }

  // ============================================
  // 10. QTY BUTTONS — handled by the inline cart script in
  // layout/theme.liquid (single source of truth, no double POSTs).
  // ============================================

  // ============================================
  // 11. SMOOTH SCROLL FOR ANCHOR LINKS
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // ============================================
  // 13. PROMO-TILE REFLOW — product grids
  //     On phones (<768px) collection/shop-all grids run 2-up. If two
  //     promo tiles land in the same or adjacent rows they read as a
  //     broken double-banner. This walks the grid and, whenever fewer
  //     than 2 product cards separate two promo tiles, moves the later
  //     promo tile forward so it always follows at least 2 product cards.
  // ============================================
  function reflowPromoTiles(grid) {
    if (!grid) return;
    var children = Array.prototype.slice.call(grid.children);
    var sinceLastPromo = Infinity;
    children.forEach(function (el) {
      var isPromo = el.classList.contains('promo-card');
      var isProduct = el.classList.contains('product-card') && !isPromo;
      if (isPromo) {
        if (sinceLastPromo < 2) {
          // Not enough product cards since the previous promo — push this
          // one later in the DOM, after the next product card.
          var next = el.nextElementSibling;
          while (next && (next.classList.contains('promo-card') || !next.classList.contains('product-card'))) {
            next = next.nextElementSibling;
          }
          if (next && next.nextElementSibling) {
            grid.insertBefore(el, next.nextElementSibling);
          } else if (next) {
            grid.appendChild(el);
          }
          sinceLastPromo = 0;
          return;
        }
        sinceLastPromo = 0;
      } else if (isProduct) {
        sinceLastPromo += 1;
      }
    });
  }
  // Phone position: promo_position_mobile_N metafield (data-pos-mobile) places
  // the tile before the Nth product card on the 2-up grid; desktop order is
  // restored when the viewport widens again.
  function placeMobilePromos(grid) {
    if (!grid._deskOrder) grid._deskOrder = Array.prototype.slice.call(grid.children);
    var phone = window.innerWidth < 768;
    if (!phone) {
      grid._deskOrder.forEach(function (el) { grid.appendChild(el); });
      return;
    }
    var promos = grid._deskOrder.filter(function (el) {
      return el.classList.contains('promo-card') && parseInt(el.getAttribute('data-pos-mobile'), 10) > 0;
    });
    if (!promos.length) { reflowPromoTiles(grid); return; }
    grid._deskOrder.forEach(function (el) { grid.appendChild(el); });
    promos.forEach(function (el) { el.remove(); });
    promos.sort(function (a, b) { return a.getAttribute('data-pos-mobile') - b.getAttribute('data-pos-mobile'); });
    promos.forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-pos-mobile'), 10);
      var cards = Array.prototype.filter.call(grid.children, function (c) { return c.classList.contains('product-card') && !c.classList.contains('promo-card'); });
      var before = cards[pos - 1];
      if (before) grid.insertBefore(el, before); else grid.appendChild(el);
    });
  }
  function runPromoReflow() {
    document.querySelectorAll('#collection-grid, .shop-all-grid, #shop-all-grid').forEach(placeMobilePromos);
  }
  runPromoReflow();
  var promoReflowTimer;
  window.addEventListener('resize', function () {
    clearTimeout(promoReflowTimer);
    promoReflowTimer = setTimeout(runPromoReflow, 200);
  });

  // ============================================
  // 12. KEYFRAME INJECTION
  // ============================================
  if (!document.getElementById('duduk-keyframes')) {
    const style = document.createElement('style');
    style.id = 'duduk-keyframes';
    style.textContent = `
      @keyframes float { from{transform:translateY(0)} to{transform:translateY(-10px)} }
      @keyframes spin-slow { from{transform:rotate(0)} to{transform:rotate(360deg)} }
    `;
    document.head.appendChild(style);
  }

});

/* v109 — Klaviyo Reviews star lines start hidden (CSS) and are revealed only
   when a product has reviews, so nothing appears and then disappears. Only the
   star widgets themselves are watched (not the whole page), and a class is
   changed only when the state actually changes. */
(function () {
  function check(w) {
    // Klaviyo's widget text also contains its own CSS, so read just the count.
    var m = (w.textContent || '').match(/(\d[\d,]*)\s+reviews?/i);
    var has = !!m && parseInt(m[1].replace(/,/g, ''), 10) > 0;
    if (has !== w.classList.contains('kv-has')) w.classList.toggle('kv-has', has);
  }
  function watch(w) {
    if (w.__kvWatched) return; w.__kvWatched = true;
    check(w);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { check(w); })
        .observe(w, { childList: true, subtree: true, characterData: true });
    }
  }
  function init() { document.querySelectorAll('.klaviyo-star-rating-widget').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
